import apiClient from '../client';
import type {
  FeatureFlag,
  ResolvedFeatureFlag,
  UpdateFeatureFlagRequest,
} from '../types/featureFlag';

export const featureFlagsApi = {
  getAll: () => apiClient.get<FeatureFlag[]>('/feature-flags'),

  getById: (id: number) => apiClient.get<FeatureFlag>(`/feature-flags/${id}`),

  update: (id: number, data: UpdateFeatureFlagRequest) =>
    apiClient.put<boolean>(`/feature-flags/${id}`, data),

  setProviderOverride: (flagId: number, userId: number, isEnabled: boolean) =>
    apiClient.put<boolean>(`/feature-flags/${flagId}/providers/${userId}`, {
      isEnabled,
    }),

  removeProviderOverride: (flagId: number, userId: number) =>
    apiClient.delete<boolean>(`/feature-flags/${flagId}/providers/${userId}`),

  getResolved: () =>
    apiClient.get<ResolvedFeatureFlag[]>('/feature-flags/resolved'),
};
